import { Link } from 'react-router-dom';
import { FiHeart, FiTrash2 } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import toast from 'react-hot-toast';
import { useWishlist } from '../../context/WishlistContext';
import ProductCard from '../../components/product/ProductCard';
import './WishlistPage.css';

export default function WishlistPage() {
  const { items, removeItem, count } = useWishlist();

  const handleRemove = (product) => {
    removeItem(product._id);
    toast.success(`"${product.name.slice(0, 22)}…" removed from wishlist`);
  };

  return (
    <div className="wishlist-page">
      <div className="container">
        {/* Header */}
        <div className="page-header">
          <h1><FiHeart size={22} /> Wishlist</h1>
          <p className="text-muted">{count} saved item{count !== 1 ? 's' : ''}</p>
        </div>

        {count === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">🤍</div>
            <h3>Your wishlist is empty</h3>
            <p>Heart products you love to save them here for later.</p>
            <Link to="/products" className="btn btn-primary">Explore Products</Link>
          </div>
        ) : (
          <>
            <div className="wishlist-grid">
              <AnimatePresence>
                {items.map((product) => (
                  <motion.div
                    key={product._id}
                    className="wishlist-item-wrap"
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.18 }}
                    layout
                  >
                    <ProductCard product={product} />
                    <button
                      className="wishlist-remove-btn"
                      onClick={() => handleRemove(product)}
                      aria-label="Remove from wishlist"
                      title="Remove from wishlist"
                    >
                      <FiTrash2 size={14} />
                      Remove
                    </button>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            <div className="wishlist-footer">
              <Link to="/products" className="btn btn-ghost">← Continue Shopping</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
